import CoreBase from '../../../../../services/engines/CoreBase';
import userTopicService from '../../../../../services/UserTopicService';
import templateEngine from '../../TemplateEngine';
import responseHelper from '../../../../../services/ResponseHelper';

class UpdateLayoutHandler extends CoreBase {
    _name = 'UpdateLayoutHandler';

    /**
     * Handles jerny:updatelayout — persists new layout to the layoutRk note.
     * @param {MessageEvent} e
     * @param {HTMLIFrameElement} iframe
     * @param {string} tid - entry.tid — rk of the template note
     */
    handle = async (e, iframe, tid) => {
        try {
            if (e.source !== iframe?.contentWindow) return;

            const layout = e.data?.layout;
            if (!layout) return;

            const templateNote = templateEngine.getTemplate(tid);
            if (!templateNote) return;

            let templateJson;
            try {
                templateJson = JSON.parse(templateNote.body);
            } catch (_) {
                this.logError('handle', 'template body is not valid JSON');
                return;
            }

            const layoutRk = templateJson.layoutRk;
            if (!layoutRk) {
                this.logError('handle', 'no layoutRk in template JSON');
                return;
            }

            const body = JSON.stringify(layout);
            const resp = await userTopicService.updateJournalBody(layoutRk, body);
            if (responseHelper.check(resp, '', this._name) < 0) return;

            // Cache updaten — DataInjector leest layout uit TemplateCache bij rebuild
            const layoutNote = templateEngine.getTemplate(layoutRk);
            console.log('[UpdateLayoutHandler] layoutNote=', layoutNote, 'layoutRk=', layoutRk);
            if (layoutNote) {
                layoutNote.body = body;
                console.log('[UpdateLayoutHandler] cache updated body=', body);
            }
        } catch (error) {
            this.logError('handle', error.message);
        }
    };
}

const updateLayoutHandler = new UpdateLayoutHandler();
export default updateLayoutHandler;
